import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ps-4 my-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "table table-striped" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "99" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-end text-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "total" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        type: "h5",
        localizedKey: "Transportation",
        text: "Transportation"
      }),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-tertiary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editTransportation(-1))),
              disabled: _ctx.disabled
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add",
                text: "Add"
              })
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.showCopyButtons && !_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-tertiary ms-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('copySectionFromOther')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Copy FROM others",
                text: "Copy FROM others"
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.showCopyButtons && !_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn btn-tertiary ms-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('copySectionToOther')))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Copy TO others",
                text: "Copy TO others"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Material",
              text: "Material"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Origin Country",
              text: "Origin Country"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Destination Country",
              text: "Destination Country"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Transports",
              text: "Transports"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Transport CO2e Grams",
              text: "Transport CO2e Grams"
            })
          ]),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("td", _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.filteredCurrentTransportation.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
              _createElementVNode("td", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  localizedKey: "No Elements Found",
                  text: "No Elements Found"
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCurrentTransportation, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", null, _toDisplayString(item.rawMaterial.text), 1),
            _createElementVNode("td", null, _toDisplayString(item.countryOfOrigin), 1),
            _createElementVNode("td", null, _toDisplayString(item.countryOfDestination), 1),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.transportTypes, (type, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fs-12 mb-1",
                  key: j
                }, _toDisplayString(type.transportType) + " - " + _toDisplayString(_ctx.$filters.approximation(type.transportCO2)), 1))
              }), 128)),
              (item.transportTypes.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "--"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, _toDisplayString(_ctx.$filters.approximation(item.transportCO2)), 1),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary me-1",
                      onClick: ($event: any) => (_ctx.editTransportation(i))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Edit",
                        text: "Edit"
                      })
                    ], 8, _hoisted_13),
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: ($event: any) => (_ctx.removeTransportation(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Remove",
                        text: "Remove"
                      })
                    ], 8, _hoisted_14)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("tr", _hoisted_15, [
          _createElementVNode("td", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Total",
                text: "Total"
              })
            ])
          ]),
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _createElementVNode("td", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.approximation(_ctx.$utils.getTotal("transportCO2", _ctx.filteredCurrentTransportation))), 1)
          ]),
          _hoisted_19
        ])
      ])
    ])
  ]))
}